export const GET_SENSITIVE_GOOD_RETURN_LIST = "GET_SENSITIVE_GOOD_RETURN_LIST";
export const GET_MEMBERS = "GET_MEMBERS";
export const POST_SENSITIVE_GOOD_RETURN = "POST_SENSITIVE_GOOD_RETURN";
export const SHOW_SENSITIVE_GOOD_RETURN = "SHOW_SENSITIVE_GOOD_RETURN";
export const UPDATE_SENSITIVE_GOOD_RETURN = "UPDATE_SENSITIVE_GOOD_RETURN";
export const DELETE_SENSITIVE_GOOD_RETURN = "DELETE_SENSITIVE_GOOD_RETURN";